import { SiteDetailDto, EquifaxCreditProvider } from '@core/services/dto';

export class SiteDetailModel {
    enableDefaultORInternational: boolean;
    enableCondensedORExpanded: boolean;
    /** Used by credit report UI to show/hide sections (e.g. EquifaxUS vs EquifaxCanada). */
    creditReportProvider: EquifaxCreditProvider;

    constructor(dto: SiteDetailDto) {
        // this.enableDefaultORInternational = dto.enableDefaultORInternational;
        // this.enableCondensedORExpanded = dto.enableCondensedORExpanded;
        this.creditReportProvider = dto?.creditReportProvider;
    }
}
